// @ts-strict-ignore
import type { getActionDataType } from 'flow/service/actions';
import type { PopulatedThreshold } from 'flow/store/engine/types';
import type { ThresholdRule } from 'flow/service/rules';
import { createContext } from 'react';

type ThresholdContextType = {
  isDynamic: boolean;
  lhsDataType: ReturnType<typeof getActionDataType>;
  populatedThreshold: PopulatedThreshold;
  rule: ThresholdRule | null;
};

export const ThresholdDefaultContext: ThresholdContextType = {
  isDynamic: false,
  lhsDataType: null,
  populatedThreshold: null,
  rule: null,
};

export const ThresholdContext = createContext<ThresholdContextType>(ThresholdDefaultContext);
